import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatchingResultsDal } from '../dal/matchingresults.dal';

@Injectable({
  providedIn: 'root',
})
export class MatchingresultsService {
  constructor(private readonly matchingResultsDal: MatchingResultsDal) {}

  searchMatchingResults(
    type: string,
    options?: {
      page?: number;
      limit?: number;
      doPagination?: boolean;
      search?: { [key: string]: string };
      sort?: { field: string; direction: number };
    }
  ): Observable<any> {
    const page = options && options.page ? options.page : undefined;
    const limit = options && options.limit ? options.limit : undefined;
    const doPagination = options && typeof options.doPagination === 'boolean' ? options.doPagination : true;
    const search = options && options.search ? options.search : undefined;
    const sort = options && options.sort ? options.sort : undefined;
    return this.matchingResultsDal.searchMatchingResults(type, page, limit, doPagination, search, sort);
  }

  elementsWithoutMatchedId(
    type: string,
    options?: { sort?: { [key: string]: string } },
    switchOrder?: boolean,
    page?: number,
    limit?: number,
    doPagination?: boolean
  ) {
    const sort = options ? options.sort : undefined;
    return this.matchingResultsDal.elementsWithoutMatchedId(type, sort, switchOrder, page, limit, doPagination);
  }

  updateMatchingResults(id: string, matchedId: string) {
    return this.matchingResultsDal.updateMatchingResults(id, matchedId);
  }

  updateUnmatchedCollections(hospital: string, form: any) {
    return this.matchingResultsDal.updateUnmatchedCollections(hospital, form);
  }

  checkPassword(password: string) {
    return this.matchingResultsDal.checkPassword(password);
  }

  deleteMatchingResults(id: string) {
    return this.matchingResultsDal.deleteMatchingResults(id);
  }
}
